import React, { createContext } from 'react';
import styles from './SideBySideContainer.module.scss';
import { ComponentRendering, ComponentParams } from '@sitecore-content-sdk/nextjs';
import { BrandAndThemeProvider } from 'components/helpers/ContextProvider/BrandAndThemeContext';
import { Themes } from 'lib/themes';

export const SideBySideContext = createContext(false); // New context

export interface SideBySideContainerProps {
  RenderingIdentifier?: string;
  colCount?: '1' | '2' | undefined;
  children?: React.ReactNode;
  rendering?: ComponentRendering;
  theme?: Themes;

  params?: ComponentParams & {
    leftPlaceholderId?: string;
    rightPlaceholderId?: string;
    numColumns?: '1' | '2';
  };
}

export const SideBySideContainer = (props: SideBySideContainerProps) => {
  const { RenderingIdentifier, colCount = '2', children } = props;

  return (
    <BrandAndThemeProvider
      theme={props.theme}
      id={RenderingIdentifier}
      className={`${styles.sideBySideContainer} ${styles[`col-${colCount}`]}`}
      data-component="authorable/shared/layout/sidebysidecontainer/sidebysidecontainer"
    >
      <SideBySideContext.Provider value={true}>{children || <div />}</SideBySideContext.Provider>
    </BrandAndThemeProvider>
  );
};
